import { useStores } from "./useStores";
import type { ChatStoreInstance } from "@/stores/chat/ChatStore";

/**
 * Hook to access the ChatStore from the root store.
 * Follows the same pattern as other domain store hooks.
 *
 * @example
 * ```tsx
 * import { useChatStore } from "@/hooks/useChatStore";
 *
 * function BuildingChat() {
 *   const chatStore = useChatStore();
 *
 *   useEffect(() => {
 *     chatStore.initThread({ buildingId, orgId, userId });
 *   }, [buildingId, orgId, userId]);
 * }
 * ```
 */
export function useChatStore(): ChatStoreInstance {
  const { chatStore } = useStores();
  return chatStore;
}
